<template>
    <v-container fluid class="pa-6">
        <DatatableV2 :displayTitle="false" :flat="false" :url="apiUrl" @exportUsageTracking="exportUsageTracking" />
        
        <v-dialog persistent width="400" v-model="showDownload">
            <v-card>
                <v-card-text class="pa-6">
                    <h5 class="icon-title">
                        {{ $t('downloadReady') }}
                        <v-btn @click="showDownload = false" text class="square">
                            <v-icon small>$close</v-icon>
                        </v-btn>
                    </h5>
                    <div class="text-center mt-4 mb-2">
                        <a :href="downloadUrl" @click="showDownload = false" download class="exportBtn">{{ $t('clickForDownload') }}</a>
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>

        <Loader v-if="openLoader"/>
    </v-container>
</template>

<script>
import GenericDataService from '../../../services/GenericDataService';
import DatatableV2 from '@/components/DatatableV2';
import Loader from '@/components/Loader.vue';

export default {
    name: "UsageTracking",
    components: {
        DatatableV2,
        Loader,
    },
    data() {
        return {
            api: this.$store.state.auth.apiUrl,
            apiUrl: "/facturation/getUsageTracking",
            downloadUrl: '',
            openLoader: false,
            showDownload:false,
        }
    },
    methods: {
        exportUsageTracking(filters) {
            this.openLoader = true;

            GenericDataService.postData("/facturation/exportUsageTracking", { "filters": filters }).then((response) => {
                this.downloadUrl = this.api + response.data.data.directDownload;
                this.showDownload = true;
                this.openLoader = false;
            }).catch((e) => {
                this.openLoader = false;
            });
        }
    },
    computed: {
    },
    mounted() {
    }
}
</script>